export const banks = [
    "001 - Banco do Brasil S.A.",
    "003 - Banco da Amazônia S.A.",
    "004 - Banco do Nordeste do Brasil S.A.",
    "007 - Banco Nacional de Desenvolvimento Econômico e Social - BNDES",
    "012 - Banco Inbursa S.A.",
    "014 - State Street Brasil S.A. - Banco Comercial",
    "021 - BANESTES S.A. Banco do Estado do Espírito Santo",
    "024 - Banco BANDEPE S.A.",
    "029 - Banco Itaú Consignado S.A.",
    "033 - Banco Santander  (Brasil)  S.A.",
    "036 - Banco Bradesco BBI S.A.",
    "037 - Banco do Estado do Pará S.A.",
    "040 - Banco Cargill S.A.",
    "041 - Banco do Estado do Rio Grande do Sul S.A.",
    "047 - Banco do Estado de Sergipe S.A.",
    "062 - Hipercard Banco Múltiplo S.A.",
    "063 - Banco Bradescard S.A.",
    "065 - Banco Andbank (Brasil) S.A.",
    "066 - Banco Morgan Stanley S.A.",
    "070 - BRB - Banco de Brasília S.A.",
    "074 - Banco J. Safra S.A.",
    "077 - Banco Inter S.A.",
    "082 - Banco Topázio S.A.",
    "083 - Banco da China Brasil S.A.",
    "094 - Banco Finaxis S.A.",
    "095 - Banco Travelex S.A.",
    "096 - Banco B3 S.A.",
    "104 - Caixa Econômica Federal",
    "107 - Banco BOCOM BBM S.A.",
    "119 - Banco Western Union do Brasil S.A.",
    "120 - Banco Rodobens S.A.",
    "121 - Banco Agibank S.A.",
    "125 - Banco Genial S.A.",
    "128 - Braza Bank S.A. Banco de Câmbio",
    "129 - UBS Brasil Banco de Investimento S.A.",
    "144 - Ebury Banco de Câmbio S.A.",
    "184 - Banco Itaú BBA S.A.",
    "212 - Banco Original S.A.",
    "217 - Banco John Deere S.A.",
    "218 - Banco BS2 S.A.",
    "222 - Banco Credit Agricole Brasil S.A.",
    "224 - Banco Fibra S.A.",
    "233 - Banco Cifra S.A.",
    "237 - Banco Bradesco S.A.",
    "243 - Banco Master S.A.",
    "249 - Banco Investcred Unibanco S.A.",
    "250 - BCV - Banco de Crédito e Varejo S.A.",
    "254 - Paraná Banco S.A.",
    "269 - Banco HSBC S.A.",
    "276 - Banco Senff S.A.",
    "299 - Banco Afinz S.A. Banco Múltiplo",
    "318 - Banco BMG S.A.",
    "320 - Bank Of China (Brasil) Banco Múltiplo S.A.",
    "341 - Itaú Unibanco S.A.",
    "348 - Banco XP S.A.",
    "366 - Banco Société Générale Brasil S.A.",
    "370 - Banco Mizuho do Brasil S.A.",
    "376 - Banco J. P. Morgan S.A.",
    "389 - Banco Mercantil do Brasil S.A.",
    "394 - Banco Bradesco Financiamentos S.A.",
    "399 - Kirton Bank S.A. - Banco Múltiplo",
    "422 - Banco Safra S.A.",
    "456 - Banco MUFG Brasil S.A.",
    "464 - Banco Sumitomo Mitsui Brasileiro S.A.",
    "473 - Banco Caixa Geral - Brasil S.A.",
    "477 - Citibank N.A.",
    "479 - Banco ItauBank S.A.",
    "487 - Deutsche Bank S.A. - Banco Alemão",
    "488 - JPMorgan Chase Bank, National Association",
    "496 - BBVA Brasil Banco de Investimento S.A.",
    "505 - Banco Credit Suisse (Brasil) S.A.",
    "600 - Banco Luso Brasileiro S.A.",
    "604 - Banco Industrial do Brasil S.A.",
    "610 - Banco VR S.A.",
    "611 - Banco Paulista S.A.",
    "612 - Banco Guanabara S.A.",
    "623 - Banco PAN S.A.",
    "626 - Banco Ficsa S.A.",
    "630 - Banco Letsbank S.A.",
    "633 - Banco Rendimento S.A.",
    "634 - Banco Triângulo S.A.",
    "643 - Banco Pine S.A.",
    "653 - Banco Voiter S.A.",
    "654 - Banco Digimais S.A.",
    "655 - Banco Votorantim S.A.",
    "707 - Banco Daycoval S.A.",
    "712 - Banco Ourinvest S.A.",
    "743 - Banco Semear S.A.",
    "745 - Banco Citibank S.A.",
    "746 - Banco Modal S.A.",
    "747 - Banco Rabobank International Brasil S.A.",
    "748 - Banco Cooperativo Sicredi S.A.",
    "751 - Scotiabank Brasil S.A. Banco Múltiplo",
    "752 - Banco BNP Paribas Brasil S.A.",
    "755 - Bank of America Merrill Lynch Banco Múltiplo S.A.",
    "756 - Banco Cooperativo Sicoob S.A.",
    "336 - Banco C6 S.A.",
    "097 - Banco CNH Industrial Capital S.A.",
    "023 - Banco CSF S.A.",
    "105 - Banco de Lage Landen Brasil S.A.",
    "335 - Banco Digio S.A.",
    "271 - Banco Fidis S.A.",
    "390 - Banco GM S.A.",
    "315 - Banco IBM S.A.",
    "652 - Banco Itaú Veículos S.A.",
    "312 - Banco Itaucard S.A.",
    "114 - Banco RCI Brasil S.A.",
    "087 - Banco Toyota do Brasil S.A.",
    "281 - Banco Volkswagen S.A.",
    "189 - Banco Volvo Brasil S.A.",
    "287 - Banco Yamaha Motor do Brasil S.A.",
    "323 - Scania Banco S.A.",
    "735 - Banco Neon S.A.",
    "010 - Credicoamo Crédito Rural Cooperativa",
    "018 - Banco Tricury S.A.",
    "025 - Banco Alfa S.A.",
    "069 - Banco Crefisa S.A.",
    "084 - Sisprime do Brasil - Cooperativa de Crédito",
    "085 - Cooperativa Central de Crédito - Ailos",
    "089 - Credisan Cooperativa de Crédito",
    "097 - Credisis - Central de Cooperativas de Crédito Ltda.",
    "098 - Credialiança Cooperativa de Crédito Rural",
    "099 - Uniprime Central Nacional - Central Nacional de Cooperativa de Crédito",
    "122 - Banco Bradesco BERJ S.A.",
    "124 - Banco Woori Bank do Brasil S.A.",
    "133 - Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e Solidária - Cresol Confederação",
    "136 - Cooperativa Central de Crédito Unicred do Brasil - Unicred do Brasil",
    "208 - Banco BTG Pactual S.A.",
    "213 - Banco Arbi S.A.",
    "241 - Banco Clássico S.A.",
    "246 - Banco ABC Brasil S.A.",
    "265 - Banco Fator S.A.",
    "266 - Banco Cédula S.A.",
    "281 - Cooperativa de Crédito Rural Coopavel",
    "300 - Banco de la Nacion Argentina",
    "322 - Cooperativa de Crédito Rural de Abelardo Luz - Sulcredi/Crediluz",
    "421 - Lar Cooperativa de Crédito - Lar Credi",
    "430 - Cooperativa de Crédito Rural Seara - Crediseara",
    "435 - Delcred Sociedade de Crédito Direto S.A.",
    "511 - Magnum Sociedade de Crédito Direto S.A.",
    "637 - Banco Sofisa S.A.",
    "753 - Novo Banco Continental - Banco Múltiplo",
    "757 - Banco Keb Hana do Brasil S.A.",
    "290 - PagBank"
]
